import Swal from 'sweetalert2';
import { UserService } from '../../_services/user.service';
import { Component, OnInit, OnDestroy, } from '@angular/core';
import { SolrService } from '../solr.service';
import { AuthenticationService } from '../../_services';
import { environment } from '../../../environments/environment'
import { take, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DocumentFormField, User } from '../../_models';
import { DocumentService } from '../../_services';
import { ElementService } from '../../_services/element.service';
import { Subject } from 'rxjs';
import { NestedTreeControl } from "@angular/cdk/tree";
import {MatTreeNestedDataSource} from '@angular/material/tree';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MatTooltipModule } from '@angular/material/tooltip';

declare const initDataRange: any;
export class FilterNode {
  name!: string;
  children: FilterNode[] = [];
  tipo!: string;
  selected!: boolean;
  indeterminate!: boolean;
  parent!: FilterNode;
  solrFieldName!: string;
  solrCore!: string;
  count!: number;
  alias!: string;
  open!: boolean;
  inputText!: string;
  values: FilterNode[] = [];
  core!: string;
}

const TREE_DATA: FilterNode[] = [
];
@Component({
  standalone:true,
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  imports: [CommonModule, FormsModule, MatTooltipModule]
})

export class FilterComponent implements OnInit, OnDestroy {

  private solrCore: string = environment.solr.core;
  private solrCoreSpec = '';
  showFilter = false;
  checkParentNodes: any[] = [];
  uncheckParentNodes: any[] = [];
  branch: any;
  tree: any;
  documentsSubscription: any;
  dataTree: any[] = [];
  tree_control: any;
  branchSubscription: any;
  hfilterSubscription: any;
  fieldChangeSubscription: any;
  solrFilter: any;
  filterItem: any;
  queryFilter = '';
  savedFilterSubscription: any;
  user: User | undefined;
  empresaInSavedFilter = false;
  itemFilterName = '';
  itemCoreName = '';
  dictValuesDateRange = {};
  initDataRange = initDataRange;
  dictTreeviewOpen = {};
  searchText = "";
  searchTextUpdate = new Subject<string>();
  dictTypeFields: any = {};
  // private destroy: boolean = false;
  currentNode: FilterNode = new FilterNode();
  initialState = [];
  currentNodeElement: FilterNode = new FilterNode();
  initialQuery: string = '';
  treeControl = new NestedTreeControl<FilterNode>(node => node.children); // See next replacement for deprecation fix
  dataSource = new MatTreeNestedDataSource<FilterNode>();
  checkedFields: any = {};

  constructor(
    private solrService: SolrService,
    public authService: AuthenticationService,
    private documentService: DocumentService,
    private userService: UserService,
    public elementService: ElementService

  ) { 
    this.dataSource.data = TREE_DATA;
  }
  hasChild = (_: number, node: FilterNode) =>  !!node.children && node.children.length > 0;
  public firstTime = true;
  public hfirstTime = true;
  public browser = '';
  public filters = {};
  public fields = [
    { name: 'category', alias: 'Categorias', tipo: ''}
  ];
  public toggleState: any = {};
  public blockFilters = false;
  public dinamicClass = '';

  ngOnInit() {
    this.searchTextUpdate.pipe(
      debounceTime(1000),
      distinctUntilChanged())
      .subscribe((value: any) => {
        this.filterStringUpdate(value);
      });
    this.user = this.authService.currentUserValue;
    this.empresaInSavedFilter = this.checkExistenceSavedFilter()
    this.solrService.getCurrentShowFilter().subscribe((val: any) => {
      this.showFilter = val;
      if(val === false) {
        this.solrService.checkedFieldFilters = [];
      }
    });
    // console.log('iniciando os filtros...');
    this.fields.forEach((field: any) => {
      this.toggleState[field.name] = {
        value: false, class: 'fa fa-arrows-alt-h'
      };
    });
    const isIE11 = !!window.navigator.userAgent.match(/Trident\/7\./);
    this.browser = '';
    if(window.navigator.language) {
      this.browser = 'chrome';
      if(isIE11) {
        this.browser = 'ie';
      }
    } else {
      this.browser = 'ie';
    }
    const solrCore = 'docs-ia';
    const facetField = 'category';

    this.blockFilters = true;

    this.fieldChangeSubscription = this.solrService.getCurrentFieldChange().subscribe((data: any) => {
      this.createFieldFilters(data);
    });

    this.dataTree = [];
    this.tree_control = this.tree = {};
    this.tree_control.scope = this;
    this.solrService.getCurrentQuery().subscribe((data: any) => {
      this.solrFilter = data;
      this.empresaInSavedFilter = this.checkExistenceSavedFilter();
    })
    this.documentService.getFilterItemDocuments().subscribe((filterItem: any) => {
      this.filterItem = filterItem;
      this.filters = {};
    });

    this.savedFilterSubscription = this.documentService.getUseSavedFilter().subscribe((value: any) => {
      if(value) {
        
        const currentUser: User = this.authService.currentUserValue;
        const empresaId = currentUser!.selectedEmpresa!._id;
        
        this.userService.getByCognitoId(currentUser.cognitoId).pipe(take(1)).subscribe((currentUser: any) => {
          const core = currentUser.savedFilter[empresaId].solrCoreSpec;
          const checkedFieldFilters = currentUser.savedFilter[empresaId].checkedFieldFilters
          this.queryFilter = currentUser.savedFilter[empresaId].queryFilter;
          this.filters = currentUser.savedFilter[empresaId].filters;
          this.solrService.solrCore = core;
          this.solrService.queryFilter = this.queryFilter;
          this.solrService.checkedFieldFilters = checkedFieldFilters
          this.solrService.setCurrentQuery(currentUser.savedFilter[empresaId].solrQuery)
          
        })
        
      }
    })
  }

  callDataRange(itemName: any, itemCoreName: any) {
    this.solrService.callDataRange(itemName, itemCoreName, this)
  }

  removeDateRangeFilter(){
    this.solrService.removeDateRangeFilter(this)
  }

  checkExistenceSavedFilter(){
    if (this.authService.currentUserValue?.savedFilter && this.authService.currentUserValue?.selectedEmpresa && Object.keys(this.authService.currentUserValue.savedFilter).indexOf(this.authService.currentUserValue.selectedEmpresa._id) != -1){
      return true;
    }
    return false;
  }

  loadFilter(){
    this.documentService.setLoadFilter(true);
  }

  deleteFilter(selectedEmpresaId: any) {
    // console.log(selectedEmpresaId)
    const currentUser = Object.assign({}, this.authService.currentUserValue);
    if (currentUser?.savedFilter && currentUser?.selectedEmpresa) {
      delete currentUser.savedFilter[currentUser.selectedEmpresa._id];
    }
    if (this.user?.savedFilter && currentUser?.selectedEmpresa) {
      delete this.user.savedFilter[currentUser.selectedEmpresa._id];
    }
    this.empresaInSavedFilter = this.checkExistenceSavedFilter()
    if (currentUser?.savedFilter && Object.keys(currentUser.savedFilter).length == 0){
      this.userService.deleteSavedFilter(currentUser).pipe(take(1)).subscribe((data: any) =>{
        // console.log('RESPONSE: ', data)
        this.authService.setCurrentUser(currentUser)
        Swal.fire({
          title: 'Filtro Excluido!',
          icon: 'success',
          showCancelButton: false,
          cancelButtonText: 'Fechar',
        });
      })

    } else {
      this.userService.updateMongo(currentUser).pipe(take(1)).subscribe((data: any) =>{
        // console.log('RESPONSE: ', data)
        this.authService.setCurrentUser(currentUser)
        Swal.fire({
          title: 'Filtro Excluido!',
          icon: 'success',
          showCancelButton: false,
          cancelButtonText: 'Fechar',
        });
      })
    }
    
  }

  saveFilter(){
    // console.log('SALVANDO FILTRO');
    
    const currentUser = Object.assign({}, this.authService.currentUserValue);
    const filters = Object.assign({}, this.filters);
    const checkedFieldFilters = Object.assign([], this.solrService.checkedFieldFilters);
    if (Object.keys(currentUser).indexOf('savedFilter') == -1){
      currentUser.savedFilter = {};
    }
    if (currentUser?.savedFilter && currentUser?.selectedEmpresa) {
      currentUser.savedFilter[currentUser.selectedEmpresa._id] = {solrQuery: this.solrFilter, filters: filters, solrCoreSpec: this.solrCoreSpec ? this.solrCoreSpec : 'docs-ia', filterItem: this.filterItem, queryFilter: this.queryFilter, checkedFieldFilters: checkedFieldFilters, clientId: currentUser.selectedEmpresa._id};
    }
    this.empresaInSavedFilter = this.checkExistenceSavedFilter()
    this.userService.updateMongo(currentUser).pipe(take(1)).subscribe((data: any) => {
      // console.log(data);
      this.authService.setCurrentUser(currentUser);
      this.user = currentUser;
      Swal.fire({
        title: 'Filtro Salvo!',
        icon: 'success',
        showCancelButton: false,
        cancelButtonText: 'Fechar',
      });
    })
    
    
  }

  removeFiterQuery(){
    let query;
    Object.keys(this.dataSource.data).forEach((key: any) => {
      this.dataSource.data[key].values.forEach((filter: any) => {
        if(filter.checked) {
          query = this.solrService.removeFilter(filter.parent.name, filter.parent.solrFieldName, filter, this.fields, this.solrCore, this.solrCoreSpec);
        }
      });
    });
    return query;
  }

  clearFilters() {
    let query = this.solrService.lastQuery;
    query = this.removeFiterQuery() || query;
    this.solrService.setCurrentQuery(query);
    this.filterStringUpdate('');
    this.showFilter = true;
  }
  getId() {
    return this.browser === 'ie' ? 'sidebar-wrapper-ie' : 'sidebar-wrapper';
  }
  
  getCountField(path: any, counts: any) {
    let count = 0;
    for(let i = 0; i < counts.values.length; i += 2) {
        if (counts.values[i].indexOf(path) !== -1) {
            count += parseInt(counts.values[i + 1]);
        }
    }
    return count;
  }
  createTree(filter: any) {
    const mytree: any[] = [];
    const  maxLevel = 0;
    const countTree = {};
    let chain = '';
    // chamando a busca facetada para obter contagem dos filtros
    for(let i = 0; i < filter.values.length; i += 2) {
      // if(filter.values[i].includes("|")){
      chain = filter.values[i].split('|');
      // }

      let currentNode = mytree;
      let path = '';
      for(let j = 0; j < chain.length; j++) {
          const wantedNode = chain[j];
          path += wantedNode + '|';
          const lastNode = currentNode;
          let k = 0;
          for(k = 0; k < currentNode.length; k++) {
              if (currentNode[k].name == wantedNode) {
                  currentNode = currentNode[k].children;
                  break;
              }
          }
          // If we couldn't find an item in this list of children
          // that has the right name, create one:
          if(lastNode == currentNode) {
              const newNode = currentNode[k] = {
                check: false,
                block: false,
                dname: wantedNode.split('//')[1],
                level: wantedNode.split('//')[0],
                name: wantedNode,
                children: [],
                count: this.getCountField(path.substr(0, path.length - 1), filter),
                path: path.substr(0, path.length - 1)
              };
              currentNode = newNode.children;
          }
        }
    }
    this.dataTree = mytree;
    this.solrService.setCurrentDataTree(this.dataTree);
  }
 
  applyFilter(filterKey: string, filterItem: any, solrCoreSpec: any) {
    // debugger;
    this.solrCoreSpec = solrCoreSpec;
    const modArray = this.fields.filter((data: any) => {
      return data.alias === filterKey;
    });
    this.blockFilters = true;
    if(filterItem.checked) {

      const query = this.solrService.applyFilter(filterKey, modArray[0].name, filterItem, this.fields, this.solrCore, this.solrCoreSpec );
      this.queryFilter =this.solrService.queryFilter
      this.solrService.setCurrentQuery(query);

    } else {
      const arr = [];
      const query = this.solrService.removeFilter(filterKey, modArray[0].name, filterItem, this.fields, this.solrCore, this.solrCoreSpec );
      this.queryFilter =this.solrService.queryFilter
      this.solrService.setCurrentQuery(query);
    }
    this.solrService.getFilterInBrowse(this.fields, this.solrCoreSpec, '', 50, true).subscribe((response: any) => {
      this.firstTime = false;
      this.blockFilters = false;
      Object.keys(response.filters).forEach((f: any) => {
        if (!(response.filters[f].hierarchical)) {
          response.filters[f].tipo = this.dictTypeFields[f].tipo
          response.filters[f].solrFieldName = this.dictTypeFields[f].solrFieldName
          response.filters[f].core = this.solrCoreSpec;
          response.filters[f].children = response.filters[f].values;
        } else {
          delete response.filters[f];
        }
      });
      
      this.dataSource.data = Object.values(response.filters);
      Object.keys(this.dataSource.data).forEach((key: any) => {
        this.setParent(this.dataSource.data[key], new FilterNode());
        this.dataSource.data[key].values.forEach((filter: any) => {
          if(filter.name+"_"+filter.parent.solrFieldName in this.checkedFields) {
            this.dataSource.data[key].open = true;
            this.dataSource.data[key].inputText = this.currentNodeElement.inputText;
            filter.checked = true;
            filter.selected = true;
          }
        });
        if (this.dataSource.data[key].solrFieldName === this.currentNodeElement.solrFieldName){
          this.dataSource.data[key].open = true;
          this.dataSource.data[key].inputText = this.currentNodeElement.inputText;
        }else{
          this.dataSource.data[key].inputText = "";
          this.dataSource.data[key].open = false;
        }
      }); 
    })
  }

  //
  createFieldFilters(category: any) {
    const self = this;
    // const branchSolr = this.solrService.checkedHierarquicalFilters[0];
    this.solrCoreSpec = category.label;
    // const branchSolr = this.solrService.checkedHierarquicalFilters[0];
    const empresa = this.authService.currentUserValue?.selectedEmpresa;
    let empresaDocFields = []
    if(empresa?.categorias) {
      empresaDocFields = empresa.categorias.filter((emp: any) => emp.tipoDocumento === category.label);
    }
    
    if(empresaDocFields.length > 0) {
      empresaDocFields = empresaDocFields[0].fields;
      this.fields = [];
      this.dictTypeFields = {};
      empresaDocFields.forEach((fieldFilter: DocumentFormField) => {
        if(fieldFilter.isFilter) {
          this.dictTypeFields[fieldFilter.label] = {tipo: fieldFilter.type, solrFieldName: fieldFilter.solrFieldName}
          this.fields.push({ name: fieldFilter.solrFieldName, alias: fieldFilter.label, tipo: fieldFilter.type});
        }
      });
      this.filterStringUpdate('');
    } else {
      this.documentService.getFormData(this.solrCoreSpec).pipe(take(1)).subscribe((data: any) => {
        this.fields = [];
        this.dictTypeFields = {};
        data.forEach((fieldFilter: DocumentFormField) => {
          if(fieldFilter.isFilter) {
            this.dictTypeFields[fieldFilter.label] = {tipo: fieldFilter.type, solrFieldName: fieldFilter.solrFieldName}
            this.fields.push({ name: fieldFilter.solrFieldName, alias: fieldFilter.label, tipo: fieldFilter.type });
          }
        });
        this.filterStringUpdate('')
      });
    }
  }

  filterStringUpdate(searchString: string){
    if(searchString.length == 0) {
      const query = this.removeFiterQuery()
      if(query) {
        this.solrService.query = query;
      }
    }
    if ((searchString && searchString.length > 2) || searchString.length == 0) {
      this.solrService.getFilterInBrowse(this.fields, this.solrCoreSpec, searchString, 50, true).subscribe((response: any) => {
        this.firstTime = false;
        this.blockFilters = false;
        Object.keys(response.filters).forEach((f: any) => {
          if (!(response.filters[f].hierarchical)) {
            response.filters[f].tipo = this.dictTypeFields[f].tipo
            response.filters[f].solrFieldName = this.dictTypeFields[f].solrFieldName
            response.filters[f].core = this.solrCoreSpec;
            response.filters[f].children = response.filters[f].values;
          } else {
            delete response.filters[f];
          }
        });
        
        this.dataSource.data = Object.values(response.filters);
        if(searchString.length > 0) {
          Object.keys(this.dataSource.data).forEach((key: any) => {
            this.setParent(this.dataSource.data[key], new FilterNode());
            if (this.dataSource.data[key].solrFieldName === this.currentNodeElement.solrFieldName){
              this.dataSource.data[key].open = true;
              this.dataSource.data[key].inputText = this.currentNodeElement.inputText;
            }else{
              this.dataSource.data[key].inputText = "";
              this.dataSource.data[key].open = false;
            }
          }); 
        }else{
          Object.keys(this.dataSource.data).forEach((key: any) => {
            this.setParent(this.dataSource.data[key], new FilterNode());
            this.dataSource.data[key].values.forEach((filter: any) => {
              filter.checked = false;
            });
          });
        }
        this.showFilter = true;
      });
    }
  }
  treeviwNavControl(node: any) {
    this.currentNodeElement = node;
    this.itemFilterName = node.solrName;
  }
  openCloseTreeview(node: any) {
    if(node.open) {
      return 'nav-item menu-is-opening menu-open';
    }
    return 'nav-item'
  }

  private setParent(node: FilterNode, parent: FilterNode) {
    node.parent = parent;
    if(node.children) {
      node.children.forEach((childNode: any) => {
        this.setParent(childNode, node);
      });
    }
  }

  private checkAllParents(node: FilterNode) {
    if(node.parent) {
      const descendants = this.treeControl.getDescendants(node.parent);
      node.parent.selected = descendants.every((child: any) => child.selected);
      node.parent.indeterminate = descendants.some((child: any) => child.selected);
      this.checkAllParents(node.parent);
    }
  }

  private itemToggle(checked: boolean, node: FilterNode) {
    node.selected = checked;
    if(node.children) {
      node.children.forEach((child: any) => {
        this.itemToggle(checked, child);
      });
    }
    this.checkAllParents(node);
  }
  getNode(node: any) {
    node.inputText = '';
    node.checked = !node.checked;
    const keyCheck = node.name+"_"+node.parent.solrFieldName;
    if(node.checked) {
      this.checkedFields[keyCheck] = node.name;
    }else{
      delete this.checkedFields[keyCheck];
    }
    this.currentNode = node;
    this.itemToggle(node.checked,node);
    this.applyFilter(node.parent.name, node, this.solrCoreSpec);
   }

  ngOnDestroy(): void {
    // removing the header
    // console.log('destruindo os filtros');
    if(this.savedFilterSubscription) {
      this.savedFilterSubscription.unsubscribe();
    }
    if(this.fieldChangeSubscription) {
      this.fieldChangeSubscription.unsubscribe();
    }

    if(this.branchSubscription) {
      this.branchSubscription.unsubscribe();
    }
    if(this.hfilterSubscription) {
      this.hfilterSubscription.unsubscribe();
    }
    this.solrService.clear();
  }
}
